export default __webpack_public_path__ + "static/media/ulcer_sight.7686f3fd.png";